import { useEffect } from 'react';
import { obterConfig } from '../lib/configSistema';

// Aplica a cor principal e a cor de destaque configuradas (Configurações → Aparência, 28/09/2026)
// por cima dos valores padrão já definidos em `:root` (index.css) — sobrescreve as variáveis CSS na
// própria página assim que a config carrega. Enquanto não carrega (ou se a API falhar), o painel já
// nasce com a cor de sempre (definida em CSS), então nunca fica "sem cor" por causa disso.
// Renderiza nada — é só o efeito colateral de aplicar as variáveis.
export default function AparenciaAplicada() {
  useEffect(() => {
    let vivo = true;
    obterConfig().then((c) => {
      if (!vivo || !c.aparencia) return;
      const raiz = document.documentElement.style;
      if (c.aparencia.corPrimaria) raiz.setProperty('--cor-primaria', c.aparencia.corPrimaria);
      if (c.aparencia.corDestaque) raiz.setProperty('--cor-destaque', c.aparencia.corDestaque);
    });
    return () => {
      vivo = false;
    };
  }, []);

  return null;
}
